import { axiosService } from '..';

export default class UpdateBusinessFrontPageClaims {
    public async execute(input: UpdateBusinessFrontPageClaimsInputDto): Promise<boolean> {
        return (await axiosService.instance.post(`businesses/organization/front-page/${input.businessId}/update-claims-data`, input)).data;
    }
}

export class UpdateBusinessFrontPageClaimsInputDto {
    public readonly businessId: number;
    public readonly claim?: string;
    public readonly subClaim?: string;

    constructor(businessId: number, claim?: string, subClaim?: string, mainImage?: File | null) {
        this.businessId = businessId;
        this.claim = claim;
        this.subClaim = subClaim;
    }
}

export const updateBusinessFrontPageClaims = new UpdateBusinessFrontPageClaims();
